<template>
  <v-container class="app">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12">
          <v-form ref="downed_bird">
            Downed Bird Information. Don't forget to take photos!.
            <v-snackbar
              v-model="messageSnackbar"
              :timeout="messageTimeout"
              id="observation_message"
              color="red"
              variant="tonal"
            >
              <div class="text pb-2">{{ observationMessage }}</div>
            </v-snackbar>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.field_species_code"
                  :items="refTables['ref_bird_species']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Species:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="record.observation_ts === ''"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <div v-bind="props">
                      <label class="datepicker-label">Incident Time:</label>
                      <Datepicker
                        v-model="record.incident_ts"
                        format="yyyy-MM-dd HH:mm"
                        :enable-time-picker="true"
                        placeholder="Incident Time"
                        type="datetime"
                        clearable
                        menu-class="w-96"
                        :is-24="true"
                        teleport
                        class="required"
                      />
                    </div>
                  </template>
                  When was the bird first observed?
                </v-tooltip>
                <v-btn @click="setTime($event, 'incident_ts')">Now</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-combobox
                      v-bind="props"
                      v-model="record.vessel_name"
                      :items="refTables['ref_vessel']"
                      item-title="title"
                      item-value="code"
                      label="Vessel (Select or enter)"
                      :return-object="false"
                    ></v-combobox>
                  </template>
                  What vessel was the bird found on?
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-number-input
                  v-model="record.latitude_wgs84"
                  filled
                  label="Latitude WGS84 (DD):"
                  control-variant="hidden"
                  :precision="5"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-number-input>
              </v-col>
              <v-col cols="12" md="6">
                <v-number-input
                  v-model="record.longitude_wgs84"
                  filled
                  control-variant="hidden"
                  :precision="5"
                  label="Longitude WGS84 (DD):"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-number-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-select
                      v-bind="props"
                      v-model="record.deck"
                      :items="numbers"
                      item-text="title"
                      item-value="code"
                      filled
                      label="Deck:"
                      clearable
                      @input="submit"
                      :disabled="isDisabled"
                      bg-color="important"
                    ></v-select>
                  </template>
                  Deck the bird was found on.
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-text-field
                      v-bind="props"
                      v-model="record.cabin"
                      filled
                      label="Cabin:"
                      clearable
                      @input="submit"
                      :disabled="isDisabled"
                      bg-color="important"
                    ></v-text-field>
                  </template>
                  Cabin the bird was found near/in.
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-text-field
                      v-bind="props"
                      v-model="record.incident_reporter"
                      filled
                      label="Incident Reporter:"
                      clearable
                      @input="submit"
                      :disabled="isDisabled"
                      bg-color="important"
                    ></v-text-field>
                  </template>
                  Who originally observed the down bird?
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.location_description"
                  filled
                  label="Location Description:"
                  clearable
                  @input="submit"
                  :disabled="isDisabled"
                  bg-color="important"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.age_code"
                  :items="refTables['ref_age']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Age:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.sex_code"
                  :items="refTables['ref_sex']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Sex:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col> 
            </v-row> -->
            <v-row>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-select
                      v-model="record.fatality_injury_code"
                      :items="refTables['ref_fatality_injury']"
                      item-text="title"
                      item-value="code"
                      filled
                      label="Fatality or Injured:"
                      clearable
                      @update:modelValue="submit"
                      :disabled="isDisabled"
                      v-bind="props"
                    >
                    </v-select>
                  </template>
                  Is the bird injured or is this a fatality.
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.specimen_condition"
                  filled
                  label="Describe injuries:"
                  clearable
                  @input="submit"
                  :disabled="isDisabled"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.nearest_structure_type_code"
                  :items="refTables['ref_structure_type']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Nearest Structure Type:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.nearest_structure_desc"
                  filled
                  label="Structure Description:"
                  clearable
                  @input="submit"
                  :disabled="isDisabled"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.current_precipitation_code"
                  :items="refTables['ref_precipitation']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Current Precipitation:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.previous_precipitation_code"
                  :items="refTables['ref_precipitation']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Precipitation last 24 hours:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <!-- <v-number-input -->
                <v-text-field
                  v-model="record.cloud_cover_percent"
                  filled
                  type="number"
                  label="Cloud cover percent:"
                  clearable
                  @input="submit"
                  :disabled="isDisabled"
                  bg-color="important"
                ></v-text-field>
                <!-- ></v-number-input> -->
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.current_wind_speed_code"
                  :items="refTables['ref_wind_speed']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Current Wind Speed:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.previous_wind_speed_code"
                  :items="refTables['ref_wind_speed']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Wind speed last 24 hours:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.current_wind_direction_code"
                  :items="refTables['ref_wind_direction']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Current Wind Direction:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.previous_wind_direction_code"
                  :items="refTables['ref_wind_direction']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Wind direction last 24 hours:"
                  clearable
                  @update:modelValue="submit"
                  :disabled="isDisabled"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.action_taken"
                  filled
                  label="Action Taken:"
                  clearable
                  @input="submit"
                  :disabled="isDisabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-text-field
                      v-model="record.pickup_person"
                      filled
                      label="Pickup Person:"
                      clearable
                      @input="submit"
                      :disabled="isDisabled"
                      v-bind="props"
                    ></v-text-field>
                  </template>
                  Who picked up the injured or deceased bird.
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label class="datepicker-label">Drop Off Time:</label>
                <Datepicker
                  v-model="record.drop_ts"
                  format="yyyy-MM-dd HH:mm"
                  :enable-time-picker="true"
                  placeholder="Drop Off Time"
                  type="datetime"
                  clearable
                  :is-24="true"
                  teleport
                  :disabled="isDisabled"
                />
                <v-btn @click="setTime($event, 'drop_ts')">Now</v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-text-field
                      v-model="record.drop_location"
                      filled
                      label="Drop Off Location:"
                      clearable
                      @input="submit"
                      :disabled="isDisabled"
                      v-bind="props"
                    ></v-text-field>
                  </template>
                  SOS box?
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.comment"
                  filled
                  label="Comment:"
                  clearable
                  @input="submit"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
//import { ABRDatetime } from "search-observe-app";
//import ABRDatetime from "/home/tmorgan/Documents/ABR/downed-bird/downed-bird-app-workspace/packages/search-observe-app/src/components/ABRDatetime.vue";
import { support } from "search-observe-app";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
//import "@vuepic/vue-datepicker/dist/main.css";
export default {
  name: "Downed-Bird-Form",
  components: { Datepicker },
  props: {
    photo_records: Array,
    selected_record: Object,
    notSearch: Boolean,
  },
  data() {
    return {
      handler: {
        submit: this.submit,
      },
      required: [(v) => !!v || "Required"],
      tableName: support.data.SURVEYPRIMARY,
      record: this.selected_record,
      messageSnackbar: false,
      messageTimeout: 6000,
      numbers: [
        { title: "1", code: "1" },
        { title: "2", code: "1" },
        { title: "3", code: "3" },
        { title: "4", code: "4" },
        { title: "5", code: "5" },
        { title: "6", code: "6" },
        { title: "7", code: "7" },
        { title: "8", code: "8" },
        { title: "9", code: "9" },
        { title: "10", code: "10" },
        { title: "11", code: "11" },
        { title: "12", code: "12" },
        { title: "13", code: "13" },
        { title: "14", code: "14" },
        { title: "15", code: "15" },
      ],
    };
  },
  mounted() {
    this.$watch(
      "selected_record",
      () => {
        this.record = this.selected_record;
      },
      { deep: true }
    );
  },
  methods: {
    submit() {
      if (this.record.field_species_code !== "") {
        let records = support.forceFieldTypes(support.data.SURVEYPRIMARY, [
          this.record,
        ]);
        this.record.invalid = false;
        support.saveRecord(support.data.SURVEYPRIMARY, records[0]);
      } else {
        this.$store.commit("shared/setAttribute", {
          attribute: "observationMessage",
          value: "Species field needs to be populated",
        });
        this.record.invalid = true;
        this.messageSnackbar = true;
        //TODO make use of a generic popup to provide feedback that the record is invalid
      }
    },
    onDateTimeSet(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date(value));
      this.submit();
    },
    setTime(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date());
      this.submit();
    },
  },

  computed: {
    isDisabled() {
      return (
        this.record.incident_ts === "" || this.record.incident_ts === undefined
      );
    },
    observationMessage() {
      return this.$store.getters["shared/getAttribute"]("observationMessage");
    },
    refTables() {
      return this.$store.getters["shared/refTables"];
    },
  },
};
</script>
<style scoped>
::v-deep(.dp__input_wrap) {
  display: flex;
  align-items: center;
}

::v-deep(.dp__input) {
  padding-right: 2.5rem; /* give space for the icon */
  display: flex;
  align-items: center;
}

::v-deep(.dp__input_icon) {
  position: static !important; /* remove absolute positioning */
  margin-left: 0.5rem;
  width: 16px;
  height: 16px;
}
.required {
  --dp-background-color: rgb(var(--v-theme-required));
}
.important {
  --dp-background-color: rgb(var(--v-theme-important));
}
.datepicker-label {
  font-size: 0.75rem; /* ~text-xs */
  color: #9ca3af; /* Tailwind's gray-400 */
  display: block;
  margin-bottom: 0.25rem;
}
::v-deep(.dp__menu) {
  width: auto;
  min-width: 300px;
  max-width: 100%;
}
</style>
